import {
  type AddressIdentifier,
  type IncomeIdentifier,
  isIncomeIdentifier,
} from '~/pages/IncomeCalculator/types';

/**
 * @param {*} year document year
 * @param {*} labelDict dictionary for labels Total Deductions and Ordinary Business Income/Loss which have different line numbers depending on the year
 * @returns string label for Total Deductions or Ordinary Business Income based off the document year
 */
export function getLabel(year, labelDict) {
  const yearKey = Object.keys(labelDict)
    .map((x) => Number.parseInt(x))
    .sort((a, b) => b - a)
    .find((y) => y <= year);
  return labelDict[yearKey];
}

export const commonKeys = {
  all: ['incomeCalculator'],
  withIdentifier: (id: IncomeIdentifier | AddressIdentifier) => [
    isIncomeIdentifier(id) ? 'employer' : 'property',
    isIncomeIdentifier(id)
      ? `${id.customerRecordId},${id.employerId}`
      : `${id?.addressId}`,
  ],
};
